export default __webpack_public_path__ + "static/media/guaranteeIcon1.e70dc984.png";